// Hand-off between an agent draft and the List Builder tab it opened to refine a drafted search.
// List Builder posts the refined filters ({type: UPDATE, token, state}); the builder tab that owns the
// token applies them and answers {type: ACK, token} so List Builder knows the agent got them.
export const AGENT_SEARCH_UPDATE = "agentSearch:update";
export const AGENT_SEARCH_ACK = "agentSearch:ack";

export const openAgentSearchChannel = () =>
  typeof window !== "undefined" && typeof window.BroadcastChannel === "function"
    ? new window.BroadcastChannel("sg-agent-search")
    : null;

export const newSearchToken = () => `s${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
